export default __webpack_public_path__ + "static/media/linkedin.ddf9b683.png";